export default __webpack_public_path__ + "static/media/logo3.6bfac4c0.svg";